// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1iH4v","savePackageButton":"ClientWallet_savePackageButton__i0LFM"};